import { makeStyles, Theme } from '@material-ui/core'
import { BaseColors } from '../../../configs/types'

const buildStyles = makeStyles((theme: Theme) => ({
  wrapper: (props: {
    withSideImage: boolean
    centeredRightSide: boolean
    baseColors: BaseColors
  }) => {
    return {
      height: '100%',
      display: 'flex',
      zIndex: 20,
      flexDirection: 'column',
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: props.baseColors.primary,
      },
      '&::-webkit-scrollbar-track': {
        backgroundColor: props.baseColors.primaryLighter,
      },
      scrollbarWidth: 'thin',
      scrollbarColor: `${props.baseColors.primary} ${props.baseColors.primaryLighter}`,
    }
  },
  container: (props: {
    withSideImage: boolean
    centeredRightSide: boolean
  }) => {
    return {
      padding: '10px',
      margin: props.centeredRightSide ? 'auto' : '0 auto',
      maxWidth: props.withSideImage ? '700px' : undefined,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    }
  },
  leftDecoration: {
    width: '30%',
    position: 'absolute',
    top: '65%',
    bottom: '25%',
    transform: 'translate(0, -50%)',
    zIndex: 1,
  },
  rightDecoration: {
    width: '30%',
    position: 'absolute',
    top: '60%',
    right: 0,
    transform: 'translate(0, -70%)',
    zIndex: 1,
  },
}))

export default buildStyles
